module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-md-9 col-xs-12\"> <div> <div id=\"api_mode_toggle\" class=\"filter-selector\"></div> <div id=\"shipment_daterange_pickers\" class=\"filter-selector\"></div> <div id=\"request_shipment_report\" class=\"filter-selector hidden-xs hidden-sm\"></div> </div> <div id=\"shipment_search\"></div> </div> </div> <div id=\"shipment_list\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/shipments/template.ejs
// module id = 816
// module chunks = 1